import { APIURL, axios } from './axios.js';
import { S3URL } from '/config.js';

export const getUserInfo = async () => {
  const res = await axios.get('/auth/me');
  return res.data;
};

export const getOrgUsers = async organizationId => {
  if (!organizationId) return [];
  const res = await axios.get(
    `${APIURL}/organization/details/${organizationId}/users/get?pageIndex=0&pageSize=0`,
  );

  // Map the response to a more usable format
  const users = (res.data?.organizationUsers?.rows || []).map(user => ({
    id: user.organizationUserId,
    uid: user.user?.uid,
    name: user.user?.full_name || 'Unknown',
    full_name: user.user?.full_name || 'Unknown',
    email: user.user?.email || '',
    img_url: user.user?.profileImageKey
      ? `${S3URL}${user.user.profileImageKey}`
      : null,
    profileImageKey: user.user?.profileImageKey,
    organizationUserId: user.organizationUserId,
    role: user.role,
    groups: user?.groups || [],
  }));

  return users;
};
export const isPartOfOrg = async (organizationId, uid) => {
  if (!organizationId || !uid) return false;
  const res = await axios.get(
    `${APIURL}/organization/${organizationId}/users/${uid}/check`,
  );

  return res.data;
};

export async function getOrganizationLogo(organizationId) {
  if (!organizationId) return null;
  const res = await axios.get(`${APIURL}/organization/${organizationId}/logo`, {
    responseType: 'blob',
  });

  return res.data;
}

export const registerUser = async data => {
  const response = await axios.post('/user/register', data);
  return response.data;
};

export const purchaseSubscription = async data => {
  const response = await axios.post('/user/subscription', data);
  return response.data;
};

export const upgradeSubscription = async data => {
  const response = await axios.post('/user/subscription/upgrade', data);
  return response.data;
};

export const getUserSubscription = async () => {
  const response = await axios.get('/user/subscription');
  return response.data;
};

export const validateToken = async () => {
  const response = await axios.get('/user/validate/token');
  return response.data;
};

export const editUserDetails = async data => {
  const response = await axios.put('/user/details', data);
  return response.data;
};

export const fetchUserDetails = async () => {
  const response = await axios.get('/user/details');
  return response.data;
};

export const getAllUserDetails = async () => {
  const response = await axios.get('/user/allDetails');
  return response.data;
};

export const uploadUserImage = async formData => {
  const response = await axios.put('/user/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getUserImage = async () => {
  const response = await axios.get('/user/image');
  return response.data;
};

export const deleteUserImage = async () => {
  const response = await axios.delete('/user/image');
  return response.data;
};

export const sendEmailVerification = async data => {
  const response = await axios.post('/user/emailVerification-link', data);
  return response.data;
};

export const renewSubscription = async data => {
  const response = await axios.put('/user/subscription/renew', data);
  return response.data;
};

export const validateEmailToken = async () => {
  const response = await axios.get('/user/validate/email-token');
  return response.data;
};

export const sendOtp = async data => {
  const response = await axios.post('/auth/send-otp', data);
  return response.data;
};

export const verifyOtp = async data => {
  const response = await axios.post('/auth/verify-otp', data);
  return response.data;
};

export const deleteAccount = async () => {
  const response = await axios.delete('/user');
  return response.data;
};

export const deleteUserBySuperAdmin = async uid => {
  const response = await axios.delete(`/user/${uid}/delete`);
  return response.data;
};

export const deactivateAccount = async uid => {
  const response = await axios.patch(`/user/${uid}/deactivate`);
  return response.data;
};

export const reactivateAccount = async uid => {
  const response = await axios.patch(`/user/${uid}/reactivate`);
  return response.data;
};

export const createPassword = async data => {
  const response = await axios.patch('/user/create-password', data);
  return response.data;
};

export const getUserBilling = async () => {
  const response = await axios.get('/user/billing');
  return response.data;
};

export const getPaymentMethods = async () => {
  const response = await axios.get('/user/payment-methods');
  return response.data;
};

export const createPaymentMethod = async data => {
  const response = await axios.post('/user/payment-method', data);
  return response.data;
};

export const setPrimaryPaymentMethod = async paymentMethodId => {
  const response = await axios.post(
    `/user/payment-method/set-primary/${paymentMethodId}`,
  );
  return response.data;
};

export const updatePaymentMethod = async (paymentMethodId, data) => {
  const response = await axios.patch(
    `/user/payment-method/${paymentMethodId}`,
    data,
  );
  return response.data;
};

export const deletePaymentMethod = async paymentMethodId => {
  const response = await axios.delete(
    `/user/payment-method/delete/${paymentMethodId}`,
  );
  return response.data;
};

export const requestResourceAccess = async params => {
  const { resourceType, resourceId, email, message } = params;

  try {
    const response = await axios.post('/user/request-access', {
      email,
      message: message || '',
      resourceType,
      resourceId,
    });

    return response.data;
  } catch (error) {
    console.error('Error requesting access:', error);
    throw error;
  }
};

export const changeUserPassword = async data => {
  const response = await axios.put('/auth/change-password', data);
  return response.data;
};
